import { Box } from "@mui/material";
import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { CMForm } from "../../components/common/Form/CMForm";
import { PageHeader } from '../../components/common/PageHeader/PageHeader';
import { addJobApplications } from "./JobApplicationsServices";
import { formFields, validationSchema } from "./JobApplicationsSchema";

export const JobApplicationsAdd = () => {

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>

                    <Row>
                        <Col lg={12}>
                            <Box component="div" sx={{ mt: 2 }}>
                                <PageHeader header="Add Job Applications" />
                                <CMForm
                                    validationSchema={validationSchema}
                                    formFields={formFields}
                                    addService={addJobApplications}
                                    listPageKey='JOB_APPLICATIONS_LIST'
                                />
                            </Box>
                        </Col>
                    </Row>

                </Container>
            </div>
        </React.Fragment>
    )
}
